import React from "react";
import { any, func } from "prop-types";
import { connect } from "react-redux";
import moment from "moment";
import history from "../../history";
import FormCreatorV2 from "../../common/FormCreatorV2";
import {
  formCreatorConvertToValues,
  getField,
  useForm,
} from "../../common/FormCreator/helpers";
import { submitDavinFoodsQuiz } from "../../redux/actions/index";

const ManualHandlingQuiz = ({ appData, submitQuiz }) => {
  const fullName = `${appData.firstName} ${appData.lastName}`;
  const quizName = "manualHandlingQuiz";
  const onboarding = appData.davinFoodsOnboarding;

  const initialData = {
    name: fullName,
    signature: fullName,
    date: moment().format("DD/MM/YYYY"),
  };
  const getVal = getField(initialData);

  const initialState = {
    blurb1: {
      htmlObj: (
        <p className="mb-2 text-center font-weight-bold">
          Please complete the Manual Handling at Davin Foods quiz as part of
          your induction with Reynolds.
        </p>
      ),
    },
    percentage: {
      title:
        "1. What percentage of lost time workplace injuries are caused by manual handling activities?",
      value: getVal("percentage"),
      type: "radio",
      radioOptions: ["50%", "10%", "37%", "82%"],
      mandatory: true,
    },
    measure: {
      title:
        "2. A control measure to reduce back injury from carrying a large pile of boxes would be...?",
      value: getVal("measure"),
      type: "radio",
      radioOptions: [
        "Put the boxes into a cardboard box",
        "Wear shoes with a heel and smooth surfaces",
        "Split the boxes into more manageable loads",
        "Work more quickly to reduce the chance of injury",
      ],
      mandatory: true,
    },
    essential: {
      title: "3. What is essential when performing a team / dual lift?",
      value: getVal("essential"),
      type: "radio",
      radioOptions: [
        "Clear precise communication",
        "Equal load bearing between all members",
        "A clear unobstructed path",
        "All of the above",
      ],
      mandatory: true,
    },
    name: {
      key: "name",
      title: "Name",
      value: getVal("name"),
      mandatory: true,
      disabled: true,
    },
    signature: {
      key: "signature",
      title: "Signature",
      value: getVal("signature"),
      mandatory: true,
      disabled: true,
    },
    date: {
      key: "date",
      title: "Date",
      value: getVal("date"),
      mandatory: true,
      disabled: true,
    },
  };
  const [fields, setField] = useForm(initialState);
  const completed =
    onboarding[quizName] &&
    (onboarding[quizName].status === "Pass" ||
      onboarding[quizName].retries === 0);
  const redirectBack = () =>
    history.push("/profile/edit/davin-foods-onboarding");
  const handleSubmit = () => {
    const fieldValuesPayload = formCreatorConvertToValues(fields);
    submitQuiz(quizName, {
      ...fieldValuesPayload,
    });
    redirectBack();
  };
  return (
    <>
      {completed ? (
        redirectBack()
      ) : (
        <FormCreatorV2
          formTitle={"Manual Handling Induction at Davin Foods Quiz (PR907)"}
          fields={fields}
          setField={setField}
          handleCancel={() => redirectBack()}
          onboardingBranch={"davinFoods"}
          useSubmitText={true}
          handleSubmit={handleSubmit}
        />
      )}
    </>
  );
};
ManualHandlingQuiz.propTypes = {
  appData: any,
  submitQuiz: func,
};
const mapDispatchToProps = {
  submitQuiz: submitDavinFoodsQuiz,
};
const mapStateToProps = (state) => ({
  appData: state.core.app,
});
const withRedux = connect(mapStateToProps, mapDispatchToProps);
export default withRedux(ManualHandlingQuiz);
